/*

  ______  _____   ______ _______  ______
 |_____/ |     | |  ____ |______ |_____/
 |    \_ |_____| |_____| |______ |    \_

 vehicle sales system

(c) 2006 - 2019 TCE <TCE-ITDevelopers@toyota-ce.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

const { transition } = require("d3");

(function () {
    "use strict";

    angular
        .module("ROGER")

        //
        .controller("SalesOrdersController", [
            "$scope", "$http", "$sessionStorage", "$uibModal", "$well", "FileSaver", "Blob", "$user", "$oidc", "$translate", "$notifications", "$decisionBox",
            function ($scope, $http, $sessionStorage, $uibModal, $well, FileSaver, Blob, user, oidc, translate, notifications, decisionBox) {

                $scope.$storage = $sessionStorage;
                $scope.user = user;

                $scope.list = [];

                $scope.search = function () {
                    return $http
                        .get("/api/retailer/" + $scope.$storage.retailer.Id + "/sales-order/search", {
                            params: {
                                searchText: $scope.$storage.salesOrders.searchText,
                                dateFrom: $scope.$storage.salesOrders.dateFrom ? $scope.$storage.salesOrders.dateFrom : "",
                                dateTo: $scope.$storage.salesOrders.dateTo ? $scope.$storage.salesOrders.dateTo : "",
                                issuedById: $scope.$storage.salesOrders.issuedById ? $scope.$storage.salesOrders.issuedById : "",
                                showClosed: $scope.$storage.salesOrders.showClosed,
                                showCanceled: $scope.$storage.salesOrders.showCanceled,
                                showIssuedById: $scope.$storage.salesOrders.showIssuedById
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function (response) {
                            $scope.list = response.data;
                        });
                };

                $scope.$watch("$storage.retailer", function (newValue, oldValue) {
                    if (newValue.Id !== oldValue.Id && newValue.Id > 0) {
                        $scope.search();
                    }
                });

                $scope.$watch("$storage.salesOrders.dateFrom", function (newValue, oldValue) {
                    if (oldValue !== newValue) {
                        $scope.search();
                    }
                });

                $scope.$watch("$storage.salesOrders.dateTo", function (newValue, oldValue) {
                    if (oldValue !== newValue) {
                        $scope.search();
                    }
                });

                $scope.$watch("$storage.salesOrders.showClosed", function (newValue, oldValue) {
                    if (oldValue !== newValue) {
                        $scope.search();
                    }
                });

                $scope.$watch("$storage.salesOrders.showCanceled", function (newValue, oldValue) {
                    if (oldValue !== newValue) {
                        $scope.search();
                    }
                });

                $scope.$watch("$storage.salesOrders.showIssuedById", function (newValue, oldValue) {
                    if (oldValue !== newValue) {
                        $scope.$storage.salesOrders.issuedById = newValue ? $scope.$storage.user.Id : "";
                        $scope.search();
                    }
                });

                // Date pickers
                $scope.dateFromOptions = {};

                $scope.dateFromOpen = function ($event) {
                    $event.preventDefault();
                    $event.stopPropagation();

                    $scope.dateFromOpened = true;
                };

                $scope.dateToOptions = {};

                $scope.dateToOpen = function ($event) {
                    $event.preventDefault();
                    $event.stopPropagation();

                    $scope.dateToOpened = true;
                };

                // Sorting
                $scope.sorting = function (orderName) {
                    if ($scope.$storage.salesOrders.orderName === orderName) {
                        $scope.$storage.salesOrders.orderDesc = !$scope.$storage.salesOrders.orderDesc;
                    } else {
                        $scope.$storage.salesOrders.orderName = orderName;
                        $scope.$storage.salesOrders.orderDesc = false;
                    }
                };

                $scope.sortingClass = function (orderName) {
                    if ($scope.$storage.salesOrders.orderName === orderName) {
                        if ($scope.$storage.salesOrders.orderDesc) {
                            return "fa fa-caret-down";
                        } else {
                            return "fa fa-caret-up";
                        }
                    } else {
                        return "";
                    }
                };

                // Styling
                $scope.getItemStripeClass = function (item) {
                    // 1 - DRA, 2 - CRE
                    if (item.StatusId === 1 || item.StatusId === 2) {
                        return "bg-red";
                        // 3 - NCO, 4 - FLX
                    } else if (item.StatusId === 3 || item.StatusId === 4) {
                        return "bg-yellow";
                        // 5 - COV
                    } else if (item.StatusId === 5) {
                        return "bg-green";
                        // 6 - CLO, 7 - CAN
                    } else {
                        return "";
                    }
                };

                $scope.getItemRowClass = function (item) {
                    if (item.StatusId === 7) {
                        return "gray strikeout";
                    } else {
                        return "";
                    }
                };

                // Customer
                $scope.getCustomerUrl = function (item) {
                    if (item.CustomerWellId) {
                        return $well.getPartyUrl(item.CustomerWellId);
                    } else {
                        return null;
                    }
                };

                $scope.getEndCustomerUrl = function (item) {
                    if (item.EndCustomerWellId) {
                        return $well.getPartyUrl(item.EndCustomerWellId);
                    } else {
                        return null;
                    }
                };

                // Show ETA history
                $scope.showETAHistory = function (item) {
                    return $http
                        .get("/api/logistic/eta-history", {
                            params: {
                                retailerId: $scope.$storage.retailer.Id,
                                salesOrderLineId: item.LineId
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function (response) {
                            var etaHistory = response.data;
                            if (etaHistory.length > 0) {
                                $uibModal.open({
                                    template: require("../Show/ShowETAHistory.html"),
                                    controller: "ShowETAHistoryController",
                                    resolve: {
                                        etaHistory: function () {
                                            return etaHistory;
                                        }
                                    }
                                });
                            }
                        });
                };

                // Delete Sales Order Line
                $scope.cancelSalesOrderLine = function (item) {
                    return decisionBox
                        .showConfirm(
                            "SalesOrderLineCancelTitle",
                            "SalesOrderLineCancelMessage",
                            "Yes",
                            "No"
                        )
                        .result
                        .then(function () {
                            return _cancelSalesOrderLine($scope.$storage.retailer.Id, item.LineId)
                                .then(function () {
                                    return $scope.search();
                                });
                        }, function (data) { });
                };

                function _cancelSalesOrderLine(retailerId, salesOrderLineId) {
                    return $http
                        .delete("/api/retailer/" + retailerId + "/sales-order/line/" + salesOrderLineId, {
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function () {
                            translate("SalesOrderLineCanceledSuscessfully")
                                .then(function (translation) {
                                    notifications.addSuccess(translation);
                                }, function () {
                                    notifications.addSuccess("Sales order canceled successfully.");
                                });
                        }, function (error) {
                            translate("SalesOrderLineCancelFailed")
                                .then(function (translation) {
                                    notifications.addError(translation, error);
                                }, function () {
                                    notifications.addError("Sales order cancel failed.", error);
                                });
                        });
                }

                // 
                $scope.downloadFile = function (id) {
                    _downloadFile(id);
                }

                function _downloadFile(id) {
                    return $http.get("/api/invoice/" + id + "/download", {
                        responseType: 'arraybuffer',
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        },
                        skipInterceptors: true
                    })
                        .then(function (response) {
                            var contentDisposition = response.headers("content-disposition");
                            var regex = /filename="*([^"].+[^"])"*;/g;
                            var result = regex.exec(contentDisposition);
                            var fileName = result[1];
                            var data = new Blob([response.data], { type: response.headers("content-type") });
                            FileSaver.saveAs(data, fileName);
                        }, function (data) {
                            translate(['InvoiceAttachmentDownloadError.Message', 'InvoiceAttachmentDownloadError.Name'])
                                .then(function (translations) {
                                    notifications.addError(
                                        translations['InvoiceAttachmentDownloadError.Name'],
                                        translations['InvoiceAttachmentDownloadError.Message']
                                    );
                                }, function () {
                                    notifications.addError(
                                        'Error',
                                        'An error occured when downloading attachments'
                                    );
                                })
                        });
                }

                // Find best ETA
                $scope.findBestETA = function (item) {
                    return $http
                        .get("/api/catalog/find-best-eta", {
                            params: {
                                retailerId: $scope.$storage.retailer.Id,
                                modelColorId: item.ModelColorId
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function (response) {
                            var bestEtaCar = response.data;
                            if (bestEtaCar !== 0) {
                                $uibModal.open({
                                    template: require("../Show/ShowBestETA.html"),
                                    controller: "ShowBestETAController",
                                    resolve: {
                                        bestEtaCar: function () {
                                            return bestEtaCar;
                                        }
                                    }
                                });
                            }
                        });
                };

                if ($scope.$storage.retailer !== null && $scope.$storage.retailer.Id > 0) {
                    $scope.search();
                }
            }
        ]);

})();
